module.exports = __webpack_public_path__ + "media/images/emblems/Scuol_wappen-9e524a41eb36200578c7542234e32b25.svg";